var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronUpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1010_2411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.263565 4.80335C0.0907833 4.97983 0 5.1975 0 5.4534C0 5.97404 0.415846 6.39759 0.931259 6.39759C1.1919 6.39759 1.43204 6.29169 1.61946 6.0976L5.611 1.9737H5.13366L9.11348 6.0976C9.3009 6.29464 9.54398 6.39759 9.79876 6.39759C10.3112 6.39759 10.73 5.97404 10.73 5.4534C10.73 5.19456 10.6421 4.9769 10.4635 4.80335L6.13521 0.352972C5.90092 0.114716 5.66079 0.00588285 5.36794 0C5.07508 0 4.83495 0.111774 4.59774 0.352972L0.263565 4.80335Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1010_2411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.73,
    height: 6.73,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpIcon);
export default __webpack_public_path__ + "static/media/ChevronUpIcon.b0dea55fc0b742ffbcea9c7c30fd4ad0.svg";
export { ForwardRef as ReactComponent };